import * as t from 'ts-schema';
import * as OfferingType from '../constants/OfferingType';
export const offeringTypeValueSchema = t.union(...Object.values(OfferingType).map(val => t.literal(val)));